import momentJalaali from "moment-jalali";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Card, Col, FormGroup, OverlayTrigger, Popover, Row } from "react-bootstrap";
import ModalImportFromExcel from "../../Pages/ModalImportFromExcel";
import BihamtaTable from "../../Components/BihamtaTable";
import { CashStack, CheckLg, CloudUploadFill, DashCircle, Download, ExclamationTriangle, EyeFill, EyeSlashFill, FileEarmark, FileEarmarkExcelFill, FileEarmarkPlus, FileEarmarkX, FileExcelFill, Link45deg, List, Pencil, PencilFill, PlusCircle, Printer, Reply, ReplyAll, Search, Trash } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, faTimes } from "@fortawesome/free-solid-svg-icons";
import { addEditCard, saveCards, saveSubCards, searchCards, getAllGuaranteeHolders, deleteCard, deleteCards, updateCardsAgencyID, updateCardsProductID, updateCardsPrintStatus } from "../store/api/GuaranteeApi";
import { useDispatch, useSelector } from "react-redux";
import { attachFile, deleteAttachment, downloadFile, exportToExcel, getAttachmentList, isWebApp, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalGuaranteeSubProducts from "../Components/ModalGuaranteeSubProducts";
import { setDialog } from "../store/api/GetAllProduct";
import { Alert, Table } from "react-bootstrap";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import PopGuaranteeCard from "../Components/PopGuaranteeCard";
import { addGuaranteeCardsInvoice } from "../../Sale/store/api/Invoice";
import PopGroupSaveCards from "../Components/PopGroupSaveCards";
import ModalPrintViewer from "../../Components/Modals/ModalPrintViewer";
import OverflowToolbar from "../../Components/OverflowToolbar";
import ModalSpecialDocuments from "../../Accounting/Components/ModalSpecialDocuments";

const GuaranteeCardsManagement = () => {
    // #region Constants
    const settingNames = ['ProductGrouppingType', 'GuaranteeCheck_UseProductCodeInEntringCards',
        'PreventGuaranteeCardMultiPrinting',
        'GuaranteeCheck_GuaranteeNumberIsMandatoryInsteadOfSerialNumber', "GuaranteeCheck_AllowNoProduct"];
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const { register, handleSubmit } = useForm();
    const dateFilters = useRef({});
    const inputAttach = useRef();
    const [filters, setFilters] = useState([]);
    const [showFilter, setShowFilter] = useState(true);
    const [showImportExl, setShowImportExl] = useState(false);
    const [modalSpecialDoc, setModalSpecialDoc] = useState({ show: false });
    const [exlModalInfo, setExlModalInfo] = useState(null);
    const [currentCard, setCurrentCard] = useState(null);
    const currentCardID = useRef();
    const [popProduct, setPopProduct] = useState({ show: false });
    const selectedRows = useRef([]);
    const [pending, setPending] = useState(false);
    const [holderList, setHolderList] = useState(null);
    const [modalSubProducts, setModalSubProducts] = useState({ show: false });
    const [attachList, setAttachList] = useState(null);
    const currentHolder = useRef(-1);
    const [popAgency, setPopAgency] = useState({ show: false });
    const [popStorage, setPopStorage] = useState({ show: false });
    const [modalPrintData, setModalPrintData] = useState({ show: false });
    const [jsonDataForPrint, setJsonDataForPrint] = useState(null);
    const { filterData, systemSettings, fetchedData } = useSelector(state => {
        return {
            filterData: state.guaranteeCardsReducer.gCardsFilters,
            fetchedData: state.guaranteeCardsReducer.gCardSearchList,
            systemSettings: state.SystemSettingsReducer.systemSettings
        }
    });
    const [popGroupSave, setPopGroupSave] = useState(false);
    const pgType = Array.isArray(systemSettings ?? "") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;
    const useProductCode = Array.isArray(systemSettings ?? "") ?
        systemSettings.find(s => s.SettingName === "GuaranteeCheck_UseProductCodeInEntringCards")?.SettingValue?.toLowerCase() === "true" : false;
    const gCardNoIsRequired = Array.isArray(systemSettings ?? "") ?
        systemSettings.find(s => s.SettingName === "GuaranteeCheck_GuaranteeNumberIsMandatoryInsteadOfSerialNumber")?.SettingValue?.toLowerCase() === "true" : false;
    const allowNoProduct = Array.isArray(systemSettings ?? "") ?
        systemSettings.find(s => s.SettingName === "GuaranteeCheck_AllowNoProduct")?.SettingValue?.toLowerCase() === "true" : false;
    const preventMultiPrinting = systemSettings?.find?.(s => s.SettingName === "PreventGuaranteeCardMultiPrinting")?.SettingValue?.toLowerCase() === "true";
    const exlFields = [
        { DatabaseName: "GuaranteeCardNo", DisplayName: "شماره گارانتی" },
        { DatabaseName: "SerialNumber", DisplayName: "شماره سریال" },
        { DatabaseName: "CardPrice", DisplayName: "هزینه کارت" },
        { DatabaseName: "CustomerCode", DisplayName: "کد مشتری" },
        { DatabaseName: "PGuaranteeStartDate", DisplayName: "آغاز گارانتی" },
        { DatabaseName: "PGuaranteeEndDate", DisplayName: "پایان گارانتی" },
        { DatabaseName: "PPurchaseDate", DisplayName: "تاریخ خرید" },
        { DatabaseName: "PProductCreationDate", DisplayName: "تاریخ تولید" },
        { DatabaseName: "ShopName", DisplayName: "نام فروشگاه" },
        { DatabaseName: "Description", DisplayName: "توضیحات" },
        { DatabaseName: "CustomerDescription", DisplayName: "اظهارات مشتری" },
        { DatabaseName: "AgentCode", DisplayName: "کد نمایندگی" },
        { DatabaseName: "Manufacturer", DisplayName: "تولید کننده" },
        { DatabaseName: "PInstallDeadline", DisplayName: "مهلت نصب" },
        { DatabaseName: "PActiveDeadline", DisplayName: "مهلت فعالسازی" },
        { DatabaseName: "ProductionID", DisplayName: "شناسه تولید" }

    ]
    const subProductsExlFields = [
        { DatabaseName: "SerialNumber", DisplayName: "شماره سریال قطعه" },
        { DatabaseName: "PGuaranteeStartDate", DisplayName: "آغاز گارانتی" },
        { DatabaseName: "PGuaranteeEndDate", DisplayName: "پایان گارانتی" },
    ]
    const buttonArray = [
        { key: "search", type: "submit", variant: "secondary", icon: <Search size={15} />, label: "جستجوی کارت" },
        { key: "toagency", onClick: assignToAgency, icon: <Reply size={15} />, label: "تخصیص کارتها به نماینده" },
        { key: "newcard", onClick: prepareForAddEdit, variant: "info", icon: <PlusCircle size={15} />, label: " ثبت کارت جدید" },
        { key: "delete", onClick: deleteSelectedCards, variant: "danger", icon: <DashCircle size={15} />, label: "حذف کارتهای انتخاب شده" },
        { key: "importexl", onClick: showModalImportExl, icon: <FileEarmarkX size={15} />, label: "دریافت از اکسل" },
        { key: "importsubexl", onClick: showModalImportExlForSub, className: "btn-violet", icon: <FileEarmarkX size={15} />, label: "دریافت قطعات از اکسل" },
        { key: "resid", onClick: createResid, icon: <FileEarmark size={15} />, label: "ثبت رسید انبار" },
        { key: "groupsave", onClick: setPopGroupSave, variant: "secondary", icon: <FileEarmarkPlus size={15} />, label: "ثبت گروهی کارت ها" },
        { key: "toproduct", onClick: assignProduct, variant: "info", icon: <ReplyAll size={15} />, label: "تخصیص کالا" },
        { key: "print", onClick: printCards, variant: "secondary", icon: <Printer size={15} />, label: "چاپ کارتها" },
        { key: "saleshare", onClick: showModalSpecialDocuments, variant: "info", icon: <CashStack size={15} />, label: "سهم از فروش" },
        { key: "send2Exl", onClick: toExcel, icon: <FileExcelFill size={15} />, label: "ارسال به اکسل" }
    ]
    if (useProductCode) {
        exlFields.push({ DatabaseName: "ProductCode", DisplayName: "کد محصول" });
        subProductsExlFields.push({ DatabaseName: "ProductCode", DisplayName: "کد قطعه" });
        subProductsExlFields.push({ DatabaseName: "MainProductCode", DisplayName: "کد محصول" });
    }
    else {
        exlFields.push(
            { DatabaseName: "ProductName", DisplayName: "نام/نوع محصول" },
            { DatabaseName: "ProductModel", DisplayName: "مدل محصول" })
        subProductsExlFields.push(
            { DatabaseName: "ProductHolderName", DisplayName: "مارک قطعه" },
            { DatabaseName: "ProductName", DisplayName: "نام/نوع قطعه" },
            { DatabaseName: "ProductModel", DisplayName: "مدل قطعه" }
        )
    }
    if (gCardNoIsRequired) {
        subProductsExlFields.push({ DatabaseName: "GuaranteeCardNo", DisplayName: "شماره گارانتی محصول" });
    }
    else {
        subProductsExlFields.push({ DatabaseName: "MainSerialNumber", DisplayName: "شماره سریال محصول" });
    }

    const tableCols = [
        { colTitle: "انتخاب", colName: "select", colType: "boolean", editable: true, onChange: selectRow, selectAll: selectAllRows },
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "شماره گارانتی", colName: "GuaranteeCardNo", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "شماره سریال", colName: "SerialNumber", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "شناسه رهگیری", colName: "MIMTTrackingID" },
        { colTitle: "کد محصول", colName: "ProductCode" },
        { colTitle: "نام/نوع محصول", colName: "ProductName" },
        { colTitle: "مدل محصول", colName: "ProductModel" },
        { colTitle: "هزینه کارت", colName: "CardPrice", colType: "currency" },
        { colTitle: "آغاز گارانتی", colName: "PGuaranteeStartDate" },
        { colTitle: "پایان گارانتی", colName: "PGuaranteeEndDate" },
        { colTitle: "تاریخ خرید", colName: "PPurchaseDate" },
        { colTitle: "تاریخ تولید", colName: "PProductCreationDate" },
        { colTitle: "نام فروشگاه", colName: "ShopName" },
        { colTitle: "نام نماینده", colName: "AgencyName" },
        { colTitle: "نام مشتری", colName: "CustomerName" },
        { colTitle: "استفاده شده", colName: "IsUsedInServices", colType: "boolean" },
        { colTitle: "فروش رفته", colName: "IsActive", colType: "boolean" },
        { colTitle: "رسید دارد", colName: "HasInvoice", colType: "boolean" },
        { colTitle: "خارج از گارانتی", colName: "IsGuaranteeCanceled", colType: "boolean" },
        { colTitle: "شرح ابطال", colName: "CancelDescription" },
        { colTitle: "تاریخ ثبت", colName: "PCreationDate" },
        { colTitle: "شماره سند سهم", colName: "DocNumberAndDuration" },
        { colTitle: "شناسه تولید", colName: "ProductionID" },
        { colTitle: "چاپ شده", colName: "IsPrinted", colType: "boolean" },
        { colTitle: "", colName: "CardID", style: { display: "none" }, headerStyle: { display: "none" } }
    ]
    // const filterOptions = [
    //     { key: "productName", label: "نام کالا", type: "text", width: 2 },
    //     { key: "serialNumber", label: "شماره سریال", type: "text", width: 2 },
    //     { key: "warrantyNumber", label: "شماره گارانتی", type: "text", width: 2 },
    //     { key: "status", label: "وضعیت", type: "select", width: 2, options: [{ value: true, text: "فعال" }, { value: false, text: "غیرفعال" }], value: "value", text: "text" },
    //     { key: "purchaseDate", label: "تاریخ خرید", width: 2, type: "date" },
    //     { key: "productID", label: "مشخصات کالا",width:3, type: "textButton", onButtonClick:showModalProduct, displayValue:"ProductName" }
    // ];
    // const filterOptions = [
    //     // { key: "ProductName", label: "نام/نوع کالا", type: "text", width: 2 },
    //     // { key: "ProductModel", label: "مدل کالا", type: "text", width: 2 },
    //     // { key: "GuaranteeCardNo", label: "شماره گارانتی", type: "text", width: 2 },
    //     // { key: "SerialNumber", label: "شماره سریال", type: "text", width: 2 },
    //     // { key: "ShopName", label: "نام فروشگاه", type: "text", width: 2 },
    //     // { key: "SubProductSerial", label: "سریال قطعه", type: "text", width: 2 },
    //     // { key: "CreateFromDate", label: "تاریخ ثبت از", type: "date", width: 1 },
    //     // { key: "CreateToDate", label: "تاریخ ثبت تا", type: "date", width: 1 },
    //     // { key: "GuaranteeStartFromDate", label: "آغاز گارانتی از", type: "date", width: 1 },
    //     // { key: "GuaranteeStartToDate", label: "آغاز گارانتی تا", type: "date", width: 1 },
    //     // { key: "GuaranteeEndFromDate", label: "پایان گارانتی از", type: "date", width: 1 },
    //     // { key: "GuaranteeEndToDate", label: "پایان گارانتی تا", type: "date", width: 1 },
    //     // { key: "ActiveFromDate", label: "تاریخ فروش از", type: "date", width: 1 },
    //     // { key: "ActiveToDate", label: "تاریخ فروش تا", type: "date", width: 1 },
    //     // { key: "PurchaseFromDate", label: "تاریخ خرید از", type: "date", width: 1 },
    //     // { key: "PurchaseToDate", label: "تاریخ خرید تا", type: "date", width: 1 },
    //     // { key: "HasInvoice", label: "وضعیت رسید انبار", type: "select", width: 2, options: { dataSource: [{ value: false, text: "رسید ندارد" }, { value: true, text: "رسید دارد" }], displayMember: "text", valueMember: "value" } },
    //     // { key: "IsCanceled", label: "وضعیت ابطال", type: "select", width: 2, options: { dataSource: [{ value: false, text: "گارانتی معتبر" }, { value: true, text: "خارج از گارانتی" }], displayMember: "text", valueMember: "value" } },
    //     // { key: "IsActive", label: "وضعیت فروش", type: "select", width: 2, options: { dataSource: [{ value: false, text: "فروش نرفته" }, { value: true, text: "فروش رفته" }], displayMember: "text", valueMember: "value" } },
    //     // { key: "IsUsedInService", label: "وضعیت استفاده", type: "select", width: 2, options: { dataSource: [{ value: false, text: "استفاده نشده" }, { value: true, text: "استفاده شده" }], displayMember: "text", valueMember: "value" } },
    //     // { key: "CardStatus", label: "وضعیت کارت", type: "select", width: 2, options: { dataSource: [{ value: 1, text: "عادی" }, { value: 2, text: "لیست سیاه" }], displayMember: "text", valueMember: "value" } },
    //     // { key: "HasShareSaleDocument", label: "وضعیت سهم فروش", type: "select", width: 2, options: { dataSource: [{ value: false, text: "ثبت نشده" }, { value: true, text: "ثبت شده" }], displayMember: "text", valueMember: "value" } },
    //     // { key: "MIMTTrackingID", label: "شناسه رهگیری", type: "text", width: 2 },
    //     // { key: "Manufacturer", label: "محل تولید", type: "text", width: 2 },
    //     // { key: "ProductionOperator", label: "اپراتور تولید", type: "text", width: 2 },
    //     // {
    //     //     key: "OrderBy", label: "مرتب سازی براساس", type: "select", width: 2,
    //     //     options: {
    //     //         dataSource: [{ value: "CREATE", text: "تاریخ ثبت-صعودی" },
    //     //         { value: "CREATE DESC", text: "تاریخ ثبت-نزولی" },
    //     //         { value: "ACTIVE", text: "تاریخ فعالسازی-صعودی" },
    //     //         { value: "ACTIVE DESC", text: "تاریخ فعالسازی-نزولی" },
    //     //         { value: "SERIAL", text: "سریال-صعودی" },
    //     //         { value: "SERIAL DESC", text: "سریال-نزولی" },
    //     //         { value: "CARDNO", text: "شماره کارت-صعودی" },
    //     //         { value: "CARDNO DESC", text: "شماره کارت-نزولی" },
    //     //         ], displayMember: "text", valueMember: "value",

    //     //     }
    //     // },
    //     // {
    //     //     key: "Take", label: "تعداد در صفحه", type: "select", width: 2,
    //     //     options: {
    //     //         dataSource: [
    //     //             { value: 10, text: "10" },
    //     //             { value: 20, text: "20" },
    //     //             { value: 50, text: "50" },
    //     //             { value: 100, text: "100" },
    //     //             { value: 1000, text: "1000" }
    //     //         ],
    //     //         displayMember: "text", valueMember: "value"
    //     //     }
    //     // },
    // ]
    //#endregion    
    function selectRow(row) {
        const cardID = Number(row.CardID);
        if (row.e.target.checked) {
            if (!selectedRows.current.includes(cardID)) {
                selectedRows.current.push(cardID);
            }
        }
        else {
            selectedRows.current = selectedRows.current.filter(r => r !== cardID);
        }
    }
    function selectAllRows(e) {

        selectedRows.current = [];
        const table = e.target.closest("table");
        table.style.display = "none";
        for (let i = 1; i < table.rows.length; i++) {
            const row = table.rows[i];
            //خط زیر کد را کندتر می کند بنابراین حذف شد
            //const firstChild = Array.from(row.cells).find(c=>c.getAttribute("colname") === "select");
            for (let j = 0; j < row.cells.length; j++) {
                if (row.cells[j]?.getAttribute("colname") === "select") {
                    const firstChild = row.cells[j].firstChild;
                    if (firstChild?.type === "checkbox") {
                        firstChild.checked = e.target.checked;
                    }
                }
                if (row.cells[j]?.getAttribute("colname") === "CardID") {
                    if (e.target.checked) {
                        const cardID = Number(row.cells[j].firstChild.nodeValue);
                        if (cardID > 0) {
                            selectedRows.current.push(cardID);
                        }
                    }
                }
            }
        }
        table.style.display = "table";
    }
    function loadAttachList(row) {
        currentCardID.current = row.CardID;
        getAttachmentList(row.CardID, "GuaranteeCardAttachment", setAttachList);

    }
    function delAttach(id) {
        dispatch(deleteAttachment(id, "DocumentAttachment", () => getAttachmentList(currentCardID.current, "GuaranteeCardAttachment", setAttachList)));
    }
    function attach() {
        dispatch(attachFile(inputAttach.current, currentCardID.current, "GuaranteeCardAttachment", () => getAttachmentList(currentCardID.current, "GuaranteeCardAttachment", setAttachList)));
    }
    const popAttachments = (
        (<Popover id="popAttachments" style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Button className="btn-input-tiny" style={{ top: "1px", left: "1px" }} onClick={attach}><CloudUploadFill size={25} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>تاریخ پیوست</th>
                            <th style={{ width: "50%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            attachList && Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "65%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "GuaranteeCardAttachment")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    const rowButtons = [
        { type: "common", title: "ویرایش کارت", icon: <PencilFill color="orange" size={18} className="rowBtn" />, onclick: showPopEditCard },
        {
            type: "overlay", tooltip: "پیوست ها", overlay: popAttachments, onclick: loadAttachList,
            icon: <Link45deg color="blue" size={18} className="rowBtn" />, style: { padding: 0 }
        },
        { type: "common", tooltip: "فهرست قطعات", title: "فهرست قطعات", icon: <List color="green" size={18} className="rowBtn" />, onclick: showSubProducts },
        {
            type: "delete", title: "حذف گارانتی", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف گارانتی',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteC(item)
                }))
            },
            showCondition: (row) => !row.IsUsedInServices && !row.IsGuaranteeCanceled
        }
    ]
    function showSubProducts(row) {
        setModalSubProducts({
            cardID: row.CardID,
            show: true,
            productName: row.ProductName,
            productModel: row.ProductModel,
            serialNumber: row.SerialNumber
        })
    }
    function toExcel() {
        if (pending) {
            return false;
        }
        const url = "api/GuarantyAPI/SearchCards";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("SearchGuaranteeCards", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function showModalImportExl() {
        if (!(Number(currentHolder.current) > 0)) {
            setErrorDialog(dispatch, "برندی انتخاب نشده است", "دریافت از اکسل");
            return;
        }
        const onSubmitData = (data, checkUpdate, saveCardData) => {
            for (let i = 0; i < data.length; i++) {
                if ((data[i].PProductCreationDate) ?? "") {
                    if (!momentJalaali(data[i].PProductCreationDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ تولید در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].ProductCreationDate = momentJalaali(data[i].PProductCreationDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PPurchaseDate) ?? "") {
                    if (!momentJalaali(data[i].PPurchaseDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ خرید در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].PurchaseDate = momentJalaali(data[i].PPurchaseDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PGuaranteeStartDate) ?? "") {
                    if (!momentJalaali(data[i].PGuaranteeStartDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ آغاز گارانتی در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].GuaranteeStartDate = momentJalaali(data[i].PGuaranteeStartDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PGuaranteeEndDate) ?? "") {
                    if (!momentJalaali(data[i].PGuaranteeEndDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ پایان گارانتی در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].GuaranteeEndDate = momentJalaali(data[i].PGuaranteeEndDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PInstallDeadline) ?? "") {
                    if (!momentJalaali(data[i].PInstallDeadline, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت مهلت نصب در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].InstallDeadline = momentJalaali(data[i].PInstallDeadline, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PActiveDeadline) ?? "") {
                    if (!momentJalaali(data[i].PActiveDeadline, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت مهلت نصب در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].ActiveDeadline = momentJalaali(data[i].PActiveDeadline, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                data[i].HolderID = currentHolder.current;
                data[i].ServiceType = saveCardData.ServiceType;
            }
            //setDataList({ Data: data });
            setShowImportExl(false);
            const onSave = (res) => {
                if (res.Error) {
                    setErrorDialog(dispatch, res.Error, "دریافت از اکسل");
                }
                else {
                    setErrorDialog(dispatch, "success", "دریافت از اکسل");
                }
            }
            saveCards(data, saveCardData.SaveService ?? false, saveCardData.StorageID, onSave);
        }
        const modalInfo = {};
        modalInfo.formName = "GuaranteeCards";
        modalInfo.submitData = onSubmitData;
        modalInfo.pageFields = exlFields;
        setExlModalInfo(modalInfo);
        setShowImportExl(true);
    }
    function deleteC(row) {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف گارانتی");
            }
            else {
                dispatch(searchCards(filterData));
            }
        }
        deleteCard(row.CardID, onSuccess);
    }
    function deleteSelectedCards() {
        if (selectedRows.current.length === 0) {
            setErrorDialog(dispatch, "کارتی انتخاب نشده است.", "حذف کارتهای گارانتی");
            return;
        }
        setPending(true);
        const onResponse = (res) => {
            setPending(false);
            if (res?.Error) {
                setErrorDialog(dispatch, res.Error, "حذف کارتهای گارانتی");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "حذف کارتهای گارانتی");
                selectedRows.current = [];
                dispatch(searchCards(filterData));
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف کارت گارانتی',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: () => deleteCards(selectedRows.current, onResponse)
        }))
    }
    function showModalImportExlForSub() {
        const onSubmitData = (data) => {
            for (let i = 0; i < data.length; i++) {
                if ((data[i].PGuaranteeStartDate) ?? "") {
                    if (!momentJalaali(data[i].PGuaranteeStartDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ آغاز گارانتی در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].GuaranteeStartDate = momentJalaali(data[i].PGuaranteeStartDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PGuaranteeEndDate) ?? "") {
                    if (!momentJalaali(data[i].PGuaranteeEndDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ پایان گارانتی در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].GuaranteeEndDate = momentJalaali(data[i].PGuaranteeEndDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if (useProductCode) {
                    if (!(data[i].ProductCode?.toString().length > 0)) {
                        setErrorDialog(dispatch, `کد قطعه در ردیف ${i + 1} وارد نشده است`, "دریافت از اکسل");
                        return;
                    }
                }
                else {
                    if (!(data[i].ProductName?.toString().length > 0)) {
                        setErrorDialog(dispatch, `نام/نوع قطعه در ردیف ${i + 1} وارد نشده است`, "دریافت از اکسل");
                        return;
                    }
                    if (!(data[i].ProductModel?.toString().length > 0)) {
                        setErrorDialog(dispatch, `مدل قطعه در ردیف ${i + 1} وارد نشده است`, "دریافت از اکسل");
                        return;
                    }
                    if (!(data[i].ProductHolderName?.toString().length > 0)) {
                        setErrorDialog(dispatch, `مارک قطعه در ردیف ${i + 1} وارد نشده است`, "دریافت از اکسل");
                        return;
                    }
                }
            }
            //setDataList({ Data: data });
            setShowImportExl(false);
            const onSave = (res) => {
                if (res.Error) {
                    setErrorDialog(dispatch, res.Error, "دریافت از اکسل");
                }
                else {
                    setErrorDialog(dispatch, "success", "دریافت از اکسل");
                }
            }
            saveSubCards(data, onSave);
        }
        const modalInfo = {};
        modalInfo.formName = "GuaranteeCards";
        modalInfo.submitData = onSubmitData;
        modalInfo.pageFields = subProductsExlFields;
        setExlModalInfo(modalInfo);
        setShowImportExl(true);
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        selectedRows.current = [];
        // //Date Filters
        {

            let date = document.getElementsByName("CreateFromDate")[0].value;
            if (date !== "") {
                data.CreateFromDate = dateFilters.current.CreateFromDate;
            }
            else {
                dateFilters.current.CreateFromDate = null;
            }
            date = document.getElementsByName("CreateFromDate")[0].value;
            if (date !== "") {
                data.CreateFromDate = dateFilters.current.CreateFromDate;
            }
            else {
                dateFilters.current.CreateFromDate = null;
            }
            date = document.getElementsByName("GuaranteeStartFromDate")[0].value;
            if (date !== "") {
                data.GuaranteeStartFromDate = dateFilters.current.GuaranteeStartFromDate;
            }
            else {
                dateFilters.current.GuaranteeStartFromDate = null;
            }
            date = document.getElementsByName("GuaranteeStartToDate")[0].value;
            if (date !== "") {
                data.GuaranteeStartToDate = dateFilters.current.GuaranteeStartToDate;
            }
            else {
                dateFilters.current.GuaranteeStartToDate = null;
            }
            date = document.getElementsByName("GuaranteeEndFromDate")[0].value;
            if (date !== "") {
                data.GuaranteeEndFromDate = dateFilters.current.GuaranteeEndFromDate;
            }
            else {
                dateFilters.current.GuaranteeEndFromDate = null;
            }
            date = document.getElementsByName("GuaranteeEndToDate")[0].value;
            if (date !== "") {
                data.GuaranteeEndToDate = dateFilters.current.GuaranteeEndToDate;
            }
            else {
                dateFilters.current.GuaranteeEndToDate = null;
            }
            date = document.getElementsByName("ActiveFromDate")[0].value;
            if (date !== "") {
                data.ActiveFromDate = dateFilters.current.ActiveFromDate;
            }
            else {
                dateFilters.current.ActiveFromDate = null;
            }
            date = document.getElementsByName("ActiveToDate")[0].value;
            if (date !== "") {
                data.ActiveToDate = dateFilters.current.ActiveToDate;
            }
            else {
                dateFilters.current.ActiveToDate = null;
            }
            date = document.getElementsByName("PurchaseFromDate")[0].value;
            if (date !== "") {
                data.PurchaseFromDate = dateFilters.current.PurchaseFromDate;
            }
            else {
                dateFilters.current.PurchaseFromDate = null;
            }
            date = document.getElementsByName("PurchaseToDate")[0].value;
            if (date !== "") {
                data.PurchaseToDate = dateFilters.current.PurchaseToDate;
            }
            else {
                dateFilters.current.PurchaseToDate = null;
            }
        }
        // ///////////
        // for (let i = 0; i < filters.length; i++) {
        //     const f = filters[i];
        //     data[f.key] = f.value;
        //     if (f.text) {
        //         data[`p${f.key}`] = f.text;
        //     }
        // }
        if (!data.Take) {
            data.Take = 10;
        }
        data.HolderID = currentHolder.current;
        data.Skip = 0;
        dispatch(searchCards(data));
    }
    function showPopEditCard(card) {
        setCurrentCard(card);
    }
    function showModalProduct() {
        const onSetData = (data) => {
            if (data?.ProductID) {
                const m = momentJalaali(new Date());
                const endDt = m.add(Number(data.InstallDeadLine ?? 0), "day");
                setCurrentCard({
                    ...currentCard,
                    ProductID: data.ProductID,
                    ProductCode: data.ProductCode,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel,
                    InstallDeadline: endDt.local("en").format("YYYY-MM-DD"),
                    CanEditInstallDeadline: data.CanEditInstallDeadline
                })
            }

        }
        setPopProduct({
            show: true,
            setProductData: onSetData
        })
    }
    function prepareForAddEdit(e) {
        e.pageX -= 150;
        e.pageY += 20;
        setCurrentCard({ CardID: 0, e });
    }
    function showModalStorage(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            setCurrentCard({ ...currentCard, StorageID: data?.StorageID, StorageName: data?.StorageName });
        }
        setPopStorage({
            show: true,
            isStaffStorage: false,
            setStorageData: onSelectStorage
        })
    }
    function showModalAgency() {
        const onSelect = (res) => {
            setCurrentCard({ ...currentCard, AgencyID: res?.ID, AgencyName: res?.LastName })
        }
        setPopAgency({
            show: true,
            forAgency: true,
            onSelect: onSelect
        })
    }
    function assignToAgency(e) {
        if (selectedRows.current.length === 0) {
            setErrorDialog(dispatch, "کارتی انتخاب نشده است.", "تخصیص کارتهای گارانتی");
            return;
        }
        setPending(true);
        const onResponse = (res) => {
            setPending(false);
            if (res?.Error) {
                setErrorDialog(dispatch, res.Error, "تخصیص کارتهای گارانتی");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "تخصیص کارتهای گارانتی");
                selectedRows.current = [];
                dispatch(searchCards(filterData));
            }
        }
        const onSelect = (agency) => {
            if (agency)
                updateCardsAgencyID(selectedRows.current, agency.ID, agency.Active, agency.InstallDeadline, onResponse);
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'تخصیص کارت',
            dialogText: 'آیا از تخصیص کارت مطمئن هستید؟',
            okOperation: () => setPopAgency({ show: true, forAgency: true, forUpdateGCard: true, onSelect: onSelect })
        }))

    }
    function createResid(e) {
        if (selectedRows.current.length === 0) {
            setErrorDialog(dispatch, "کارتی انتخاب نشده است.", "ثبت رسید");
            return;
        }
        setPending(true);
        const onResponse = (res) => {
            setPending(false);
            if (res?.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت رسید");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "ثبت رسید");
                selectedRows.current = [];
                dispatch(searchCards(filterData));
            }
        }
        const onSelect = (data) => {
            if (data?.StorageID)
                addGuaranteeCardsInvoice(selectedRows.current, data.StorageID, onResponse);
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'ثبت رسید',
            dialogText: 'آیا از ثبت رسید مطمئن هستید؟',
            okOperation: () => setPopStorage({ show: true, setStorageData: onSelect })
        }))

    }
    function assignProduct(e) {
        if (pending) {
            return;
        }
        if (selectedRows.current.length === 0) {
            setErrorDialog(dispatch, "کارتی انتخاب نشده است.", "بروزرسانی کالای کارتها");
            return;
        }
        if (!(Number(currentHolder.current) > 0)) {
            setErrorDialog(dispatch, "برند را از بالا سمت راست انتخاب کنید.");
            return;
        }
        setPending(true);
        const onResponse = (res) => {
            setPending(false);
            if (res?.Error) {
                setErrorDialog(dispatch, res.Error, "بروزرسانی کالای کارتها");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "بروزرسانی کالای کارتها");
                selectedRows.current = [];
                dispatch(searchCards(filterData));
            }
        }
        const onSelect = (product) => {
            if (product)
                updateCardsProductID(selectedRows.current, product.ProductID, currentHolder.current, onResponse);
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'تخصیص کالا',
            dialogText: 'آیا از تخصیص کالا به این کارتها مطمئن هستید؟',
            okOperation: () => setPopProduct({ show: true, setProductData: onSelect })
        }))

    }
    function printCards(e) {

        if (!fetchedData?.Data || selectedRows.current.length === 0) {
            setErrorDialog(dispatch, "کارتی انتخاب نشده است.", "بروزرسانی کالای کارتها");
            return;
        }
        const printRows = fetchedData.Data.filter(c => selectedRows.current.includes(Number(c.CardID)));
        const isPrinted = printRows.some(p => p.IsPrinted?.toString() === "true");
        if (isPrinted && preventMultiPrinting) {
            setErrorDialog(dispatch, "تنها یک بار مجاز به چاپ هر کارت هستید.", "چاپ کارتها");
            return;
        }
        setJsonDataForPrint(printRows);
        const onPrint = () => {

            updateCardsPrintStatus(selectedRows.current, () => search(filterData??{}));
        }
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: "GuaranteeCards", onPrint: onPrint });
    }
    function printGroupSavedCards(data) {
        if (!Array.isArray(data)) {
            return;
        }
        setJsonDataForPrint(data);
        const onPrint = () => {

            const cardIDs = data.map(d=>d.CardID);
            updateCardsPrintStatus(cardIDs, () => search({...filterData,Take:1000}));
        }
        setModalPrintData({ show: true, designMode: false, reportName: "GuaranteeCards", onPrint: onPrint });
    }
    function showModalSpecialDocuments() {

        if (!fetchedData?.Data || selectedRows.current.length === 0) {
            setErrorDialog(dispatch, "کارتی انتخاب نشده است.", "بروزرسانی کالای کارتها");
            return;
        }
        setModalSpecialDoc({
            show: true,
            type: "guaranteecardsaleshare",
            cardIDs: selectedRows.current
        })

    };
    function onDateChange(value, name) {
        const oldDate = dateFilters.current[name];
        const newDate = value.local("en").format("YYYY-MM-DD");
        const pDate = value.local("fa").format("jYYYY/jMM/jDD");
        if (newDate !== (oldDate ?? "")) {
            dateFilters.current[name] = newDate;
            dateFilters.current[`P${name}`] = pDate;
        }
    }
    function handleEmptyDate(e) {
        console.log(e);
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        getAllGuaranteeHolders(null, setHolderList);
        dispatch(getSystemSettings(settingNames));
    }, []);

    return (
        <div className="container-fluid mt-1">
            <br />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} defaultSalePrice=""
                defaultSalePriceLabel="" defaultStorages="" hideNewProduct={true} />
            <ModalSpecialDocuments popData={modalSpecialDoc} setPopData={setModalSpecialDoc} />
            <ModalSelectStaff setPopSelectStaff={setPopAgency} popData={popAgency} />
            <PopGuaranteeCard
                currentCard={currentCard}
                filterData={filterData}
                holderList={holderList}
                search={search}
                setCurrentCard={setCurrentCard}
                showModalAgency={showModalAgency}
                showModalProduct={showModalProduct}
                showModalStorage={showModalStorage}
                allowNoProduct={allowNoProduct} />
            <PopGroupSaveCards popData={popGroupSave} setPopData={setPopGroupSave} holderList={holderList} pgType={pgType} allowNoProduct={allowNoProduct} printCards={printGroupSavedCards}/>
            <ModalPrintViewer modalData={modalPrintData} setModalData={setModalPrintData} jsonObject={jsonDataForPrint} fetchBody={{ ...filterData }} />
            <Card style={{ textAlign: "right" }}>
                {
                    exlModalInfo &&
                    <ModalImportFromExcel show={showImportExl} setShow={setShowImportExl}
                        submitData={exlModalInfo.submitData}
                        pageFields={exlModalInfo.pageFields}
                        formName={exlModalInfo.formName} />
                }
                <ModalGuaranteeSubProducts popData={modalSubProducts} setPopData={setModalSubProducts} productGrouppingType={pgType} />
                <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faClipboardList} size="lg" />&nbsp;
                    مدیریت کارت های گارانتی
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <FormGroup className="col-md-2 mt-0">
                        <label>نام برند: </label>
                        {
                            Array.isArray(holderList ?? "") ?
                                <select className="tableRowInput" onChange={e => currentHolder.current = e.target.value}>
                                    <option value="">انتخاب کنید</option>
                                    {holderList.map((item, i) =>
                                        <option key={i} value={item.ID}>{item.HolderName}</option>)
                                    }
                                </select> :
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                        }
                    </FormGroup>
                    <form readOnly onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder mt-3">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <Col md={2} xs={6} className="form-group">
                                <label>نام/نوع کالا: </label>
                                <input className="search-input" name="ProductName" ref={register({})} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>مدل کالا: </label>
                                <input className="search-input" name="ProductModel" ref={register({})} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>شماره گارانتی: </label>
                                <input className="search-input" name="GuaranteeCardNo" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>شماره سریال: </label>
                                <input className="search-input" name="SerialNumber" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>نام فروشگاه: </label>
                                <input className="search-input" name="ShopName" ref={register({})} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>شماره سریال قطعه:</label>
                                <input className="search-input" name="SubProductSerial" ref={register({})} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingLeft: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ ثبت از">تاریخ ثبت از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreateFromDate" setTodayOnBlur={false}
                                    //onChange={value => dateFilters.current.CreateFromDate = value.local("en").format("YYYY-MM-DD")} 
                                    onChange={value => onDateChange(value, "CreateFromDate")} onBlur={handleEmptyDate}
                                />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingRight: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ ثبت تا">تاریخ ثبت تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreateToDate" setTodayOnBlur={false}
                                    //onChange={value => dateFilters.current.CreateToDate = value.local("en").format("YYYY-MM-DD")} 
                                    onChange={value => onDateChange(value, "CreateToDate")} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingLeft: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="آغاز گارانتی از">آغاز گارانتی از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="GuaranteeStartFromDate" setTodayOnBlur={false}
                                    // onChange={value => dateFilters.current.GuaranteeStartFromDate = value.local("en").format("YYYY-MM-DD")}
                                    onChange={value => onDateChange(value, "GuaranteeStartFromDate")} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingRight: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="آغاز گارانتی تا">آغاز گارانتی تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="GuaranteeStartToDate" setTodayOnBlur={false}
                                    // onChange={value => dateFilters.current.GuaranteeStartToDate = value.local("en").format("YYYY-MM-DD")}
                                    onChange={value => onDateChange(value, "GuaranteeStartToDate")} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingLeft: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="پایان گارنتی از">پایان گارانتی از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="GuaranteeEndFromDate" setTodayOnBlur={false}
                                    // onChange={value => dateFilters.current.GuaranteeEndFromDate = value.local("en").format("YYYY-MM-DD")}
                                    onChange={value => onDateChange(value, "GuaranteeEndFromDate")} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingRight: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="پایان گارانتی تا">پایان گارانتی تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="GuaranteeEndToDate" setTodayOnBlur={false}
                                    // onChange={value => dateFilters.current.GuaranteeEndToDate = value.local("en").format("YYYY-MM-DD")} 
                                    onChange={value => onDateChange(value, "GuaranteeEndToDate")} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingLeft: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ فروش از">تاریخ فروش از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="ActiveFromDate" setTodayOnBlur={false}
                                    // onChange={value => dateFilters.current.ActiveFromDate = value.local("en").format("YYYY-MM-DD")} 
                                    onChange={value => onDateChange(value, "")} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingRight: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ فروش تا">تاریخ فروش تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="ActiveToDate" setTodayOnBlur={false}
                                    // onChange={value => dateFilters.current.ActiveToDate = value.local("en").format("YYYY-MM-DD")} 
                                    onChange={value => onDateChange(value, "ActiveToDate")} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingLeft: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ خرید از">تاریخ خرید از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="PurchaseFromDate" setTodayOnBlur={false}
                                    // onChange={value => dateFilters.current.PurchaseFromDate = value.local("en").format("YYYY-MM-DD")} 
                                    onChange={value => onDateChange(value, "PurchaseFromDate")} />
                            </Col>
                            <Col md={1} xs={6} className="form-group" style={{ paddingRight: !isMobile ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ خرید تا">تاریخ خرید تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="PurchaseToDate" setTodayOnBlur={false}
                                    // onChange={value => dateFilters.current.PurchaseToDate = value.local("en").format("YYYY-MM-DD")} 
                                    onChange={value => onDateChange(value, "PurchaseToDate")} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>وضعیت استفاده: </label>
                                <select className="search-input" name="IsUsedInService" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>استفاده نشده</option>
                                    <option value={true}>استفاده شده</option>
                                </select>
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>وضعیت کارت: </label>
                                <select className="search-input" name="CardStatus" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={1}>عادی</option>
                                    <option value={2}>لیست سیاه</option>
                                </select>
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label title="شناسه رهگیری وزارت صنعت، معدن و تجارت">شناسه رهگیری:</label>
                                <input className="search-input" name="MIMTTrackingID" ref={register({})} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>وضعیت فروش: </label>
                                <select className="search-input" name="IsActive" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>فروش نرفته</option>
                                    <option value={true}>فروش رفته</option>
                                </select>
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>وضعیت ابطال: </label>
                                <select className="search-input" name="IsCanceled" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>گارانتی معتبر</option>
                                    <option value={true}>خارج از گارانتی</option>
                                </select>
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label >محل تولید:</label>
                                <input className="search-input" name="Manufacturer" ref={register({})} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>اپراتور تولید:</label>
                                <input className="search-input" name="ProductionOperator" ref={register({})} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>شناسه تولید:</label>
                                <input className="search-input" name="ProductionID" ref={register({})} />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>وضعیت رسید انبار:</label>
                                <select className="search-input" name="HasInvoice" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>رسید ندارد</option>
                                    <option value={true}>رسید دارد</option>
                                </select>
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>وضعیت سهم فروش:</label>
                                <select className="search-input" name="HasShareSaleDocument" ref={register({})}>
                                    <option value={false}>ثبت نشده</option>
                                    <option value={true}>ثبت شده</option>
                                </select>
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label>وضعیت چاپ:</label>
                                <select className="search-input" name="IsPrinted" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>چاپ نشده</option>
                                    <option value={true}>چاپ شده</option>
                                </select>
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <label className="ellipsisLabel">مرتب سازی براساس:</label>
                                <select className="search-input" name="OrderBy" ref={register({})}>
                                    <option value="CREATE">تاریخ ثبت-صعودی</option>
                                    <option value="CREATE DESC">تاریخ ثبت-نزولی</option>
                                    <option value="ACTIVE">تاریخ فعالسازی-صعودی</option>
                                    <option value="ACTIVE DESC">تاریخ فعالسازی-نزولی</option>
                                    <option value="SERIAL">سریال-صعودی</option>
                                    <option value="SERIAL DESC">سریال-نزولی</option>
                                    <option value="CARDNO">شماره کارت-صعودی</option>
                                    <option value="CARDNO DESC">شماره کارت-نزولی</option>
                                </select>
                            </Col>
                            {/* <Col md={2} xs={6} className="form-group">
                                <label>تعداد در صفحه: </label>
                                <select className="tableRowInput" name="Take" ref={register({})}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={500}>500</option>
                                    <option value={1000}>1000</option>

                                </select>
                            </Col> */}
                        </Row>
                        <div style={{ width: "100%", padding: "5px" }}>
                            <OverflowToolbar items={buttonArray} menuIcon="⋮" />
                        </div>
                    </form>
                    {/* <DynamicFilters filterOptions={filterOptions} onSearch={search} searchTitle="جستجوی کارت" defaultFilters={filterData} filters={filters} setFilters={setFilters} />
                    <div style={{ width: "100%", padding: "5px" }}>
                        <OverflowToolbar items={buttonArray} menuIcon="⋮" />
                    </div> */}
                    <BihamtaTable filterData={filterData} searchMethod={(data) => dispatch(searchCards(data))} columns={tableCols} rowButtons={rowButtons}
                        reducerName="guaranteeCardsReducer" objectName="gCardSearchList" hasPaging className="mt-0" style={{ whiteSpace: "nowrap" }}
                        maxHeight={530} pageSizeList={[10, 20, 50, 100, 500, 1000]} />
                </Card.Body>
            </Card>
        </div >
    )
}
export default GuaranteeCardsManagement;